import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import colfaxBold from './fonts/colfax-bold';
import colfaxMedium from './fonts/colfax-medium';
import colfaxRegular from './fonts/colfax-regular';
import colfaxLight from './fonts/colfax-light';
import { BASE_FONT_SIZE } from '../../utils';
export const GlobalStyles = React.memo(createGlobalStyle `
  ${normalize}

  @font-face {
    font-family: Colfax;
    font-display: swap;
    font-weight: 600;
    font-style: normal;
    src: url(${colfaxBold}) format('woff');
  }
  @font-face {
    font-family: Colfax;
    font-display: swap;
    font-weight: 300;
    font-style: normal;
    src: url(${colfaxLight}) format('woff');
  }
  @font-face {
    font-family: Colfax;
    font-display: swap;
    font-weight: 400;
    font-style: normal;
    src: url(${colfaxRegular}) format('woff');
  }
  @font-face {
    font-family: Colfax;
    font-display: swap;
    font-weight: 500;
    font-style: normal;
    src: url(${colfaxMedium}) format('woff');
  }

  html, body {
    margin: 0;
    padding: 0;
    font-family: Colfax, Arial, Helvetica, sans-serif;
    font-size: ${BASE_FONT_SIZE}px;
    font-weight: 400;
    color: #000000;
    -webkit-overflow-scrolling: touch;
    line-height: 1.4375;
  }

  * {
    box-sizing: border-box;
  }

  /* reset links style globally to simplify next/link > a styling/selectors */
  a {
    color: inherit;
    text-decoration: none;
  }

`);
export default GlobalStyles;
//# sourceMappingURL=index.js.map